import React, { useState } from 'react';
import useTranslations from '../useTranslations';
import Navigation from '../Navigation';
import Languages from '../Languages';
import ButtonMenu from '../ButtonMenu';
import Logo from '../Logo';
import SocialLinks from '../SocialLinks';
import ContainerMenu from '../ContainerMenu';

import * as S from './styled';


const Header = () => {
  const { home } = useTranslations();
  const [toggleMenu, setToggleMenu] = useState(false);
  

  const handleToggleMenu = () => {
    setToggleMenu(!toggleMenu);
    // console.log(toggleMenu);
  }

  return (
    <S.HeaderWrapper>
        
      <ButtonMenu
          handleClick={handleToggleMenu}
          isActive={toggleMenu}
        />
      <ContainerMenu onClick={handleToggleMenu} isOpen={toggleMenu}>
        <S.LogoLink to="/" title={home} aria-label={home} onClick={handleToggleMenu}>
          <Logo />
          <div className="logo-text">dutch<br/>food processing<br/> consultants
          </div>
        </S.LogoLink>

        <S.NavLanguages>
          <Languages />
        </S.NavLanguages>

        
        <S.NavMenu>
          <Navigation onClick={() => handleToggleMenu()} />
        </S.NavMenu>
        <SocialLinks style={{color: 'var(--body-bg)'}}/>
          
                   
      </ContainerMenu>
    </S.HeaderWrapper>
  );
};

export default Header;


// isActive={toggleMenu} handleToggleMenu={handleToggleMenu}

// const scrollToTop = () => {
//   content.scrollTo({
//     top: 0,
//     behavior: 'smooth'
//   });
// }

{/* <SocialLinks style={{color: 'var(--body-bg)'}}/> */}